import React, { type ComponentProps, useEffect, useRef, useState } from 'react';
import dynamic from 'next/dynamic';
import { Badge, Button } from '@sbt-web/ui';
import { trackClick, trackView } from './tracking';
import type { default as DialogType } from './Dialog';
import styles from './index.module.scss';
import ErrorBoundary from '@sbt-web/error-boundary';
import { ThemedLogo } from './ThemedLogo';
import { useTrackImpression } from '@tools/tracking/useTrackImpression';

const Dialog = dynamic<ComponentProps<typeof DialogType>>(
  import('./Dialog').then((component) => component.default)
);

const VerifiedUserFakeDoor = () => {
  const [modalOpen, setModalOpen] = useState(false);
  const bannerRef = useRef(null);

  const setBannerRef = useTrackImpression({
    enabled: true,
    track: () => {
      trackView('notice');
    },
  });

  useEffect(() => {
    if (bannerRef?.current) {
      // Set target to be observed by the IntersectionObserver
      setBannerRef(bannerRef.current);
    }
  }, [setBannerRef, bannerRef]);

  return (
    <>
      <section className={styles['banner']} ref={bannerRef}>
        <Badge classes={[styles['badge']]} themed>
          Novità
        </Badge>
        <h3 className={`headline-6 ${styles['title']}`}>
          Badge "Profilo verificato"
        </h3>
        <p className={`body-text small ${styles['subtitle']}`}>
          Con il badge “Profilo verificato” aumenti le possibilità di chiudere
          affari
        </p>
        <ThemedLogo className={styles['logo']} />
        <Button
          classes={[styles['cta']]}
          onClick={() => {
            trackClick('interest', 'Scopri di più');
            setModalOpen(true);
          }}
        >
          Scopri di più
        </Button>
      </section>

      <Dialog open={modalOpen} onClose={() => setModalOpen(false)} />
    </>
  );
};

export const SaferFakeDoor = () => {
  return (
    <ErrorBoundary>
      <VerifiedUserFakeDoor />
    </ErrorBoundary>
  );
};

export { SaferFakeDoor as VerifiedUserFakeDoor };
